export default [
  {
    meta: { requireSignin: false },
    name: 'signout',
    path: '/signout',
    component: () => import('@/pages/signout/Signout.vue'),
  },
  {
    meta: { requireSignin: false },
    name: 'signoutAuto',
    path: '/signout/auto',
    component: () => import('@/pages/signout/Auto.vue'),
  },
]
